export default {
    LANGUAGE_IDENTIFIER: process.env.LANGUAGE_IDENTIFIER
}


// WEBPACK FOOTER //
// ./src/config/lang.js